import { render } from "./Insurance-add-subtract.vue?vue&type=template&id=7280cb52&scoped=true&ts=true"
import script from "./Insurance-add-subtract.vue?vue&type=script&lang=ts"
export * from "./Insurance-add-subtract.vue?vue&type=script&lang=ts"

import "./Insurance-add-subtract.vue?vue&type=style&index=0&id=7280cb52&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7280cb52"]])

export default __exports__